import { useEffect, useState } from "react";

interface ShareDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

export default function ShareDialog({ open, onClose, title }: ShareDialogProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (open) setCopied(false);
  }, [open]);

  if (!open) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
    } catch {
      // 忽略剪贴板权限异常，仍给出演示反馈
    }
    setCopied(true);
  };

  const options = [
    { icon: "ri-weibo-fill", label: "微博" },
    { icon: "ri-wechat-fill", label: "微信" },
    { icon: "ri-links-line", label: "复制链接", action: handleCopy },
  ];

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-foreground-950/50 animate-fade-in"
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm rounded-xl bg-background-50 p-6 border border-background-200"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-1">
          <h3 className="text-base font-bold text-foreground-950">分享</h3>
          <button
            type="button"
            aria-label="关闭"
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-500 hover:bg-background-100 cursor-pointer"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>
        <p className="text-xs text-foreground-500 mb-5 truncate">《{title}》</p>
        <div className="grid grid-cols-3 gap-3">
          {options.map((opt) => (
            <button
              key={opt.label}
              type="button"
              onClick={opt.action}
              className="flex flex-col items-center gap-2 py-3 rounded-lg bg-background-100 hover:bg-primary-100 text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer"
            >
              <i className={`${opt.icon} text-xl`} />
              <span className="text-xs">{opt.label}</span>
            </button>
          ))}
        </div>
        {copied && (
          <p className="mt-4 text-xs text-primary-700 flex items-center gap-1">
            <i className="ri-check-line" /> 链接已复制到剪贴板
          </p>
        )}
        <p className="mt-4 text-[11px] text-foreground-400">
          * 分享为演示功能，仅用于展示交互效果。
        </p>
      </div>
    </div>
  );
}